interface IconProps {
  className?: string;
  /** Filled with the current color when the product is in favorites. */
  filled?: boolean;
  /** Fill of the empty heart; the cards keep it white over the photo. */
  emptyFill?: string;
}

/** Heart glyph of the DubaiExpress marketplace mockup (favorites). */
const HeartIcon = ({
  className,
  filled = false,
  emptyFill = 'none',
}: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    fill={filled ? 'currentColor' : emptyFill}
    stroke="currentColor"
    strokeWidth={1.7}
    strokeLinejoin="round"
    aria-hidden
    className={className}
  >
    <path d="M12 20s-7.2-4.4-8.9-9C1.9 7.6 4.1 4.6 7.3 4.6c1.9 0 3.5 1 4.7 2.7 1.2-1.7 2.8-2.7 4.7-2.7 3.2 0 5.4 3 4.2 6.4-1.7 4.6-8.9 9-8.9 9z" />
  </svg>
);

export default HeartIcon;
